import React from 'react'
import { List } from 'antd'

import FormattedMessage from 'components/FormattedMessage'
import FormattedPrice from 'components/FormattedPrice'

import classNames from 'helpers/css'

import styles from './index.module.scss'

const TaxRatesList: React.FC<TaxRatesListProps> = (props) => {
  const { taxRates } = props

  const taxItemsKeys = Object.keys(taxRates || {})

  if (!taxItemsKeys.length) {
    return null
  }

  return (
    <List
      className={classNames(styles, 'contact-request__overview__content__tax-list')}
      dataSource={taxItemsKeys}
      bordered={false}
      renderItem={(taxRate) => (
        <List.Item key={taxRate}>
          <div className={classNames(styles, 'contact-request__overview__content__tax-list__item')}>
            <FormattedMessage id="common.tax.withPercent" values={{ taxRate }} />

            <p>
              <FormattedPrice price={taxRates[taxRate]} />
            </p>
          </div>
        </List.Item>
      )}
    />
  )
}

type TaxRatesListProps = {
  taxRates: {
    [rate: string]: number
  }
}

export default TaxRatesList
